export const getOption = shiGeoCoordMap => {
  return {
    tooltip: {
      trigger: 'item',
      formatter: function(params) {
        return params.data.stationname + ' : ' + params.data.num
      }
    },
    geo3D: {
      // 地图的具体参数
      map: 'china', // 地图范围
      shading: 'lambert', // 光照带来的明暗
      top: -143,
      left: 14,
      silent: true,
      light: {
        // 光照相关的设置。在 shading 为 'color' 的时候无效。
        main: {
          // 场景主光源的设置
          intensity: 1, // 主光源的强度
          shadow: true, // 主光源是否投射阴影
          shadowQuality: 'high', // 阴影的质量
          alpha: 41, // 主光源绕 x 轴偏离的角度
          beta: 3.6 // 主光源绕 y 轴偏离的角度
        },
        ambient: {
          // 全局的环境光设置。
          intensity: 10 // 环境光的强度
        }
      },
      viewControl: {
        // 用于鼠标的旋转，缩放等视角控制
        panMouseButton: 'left', // 平移操作使用的鼠标按键
        rotateMouseButton: 'right', // 旋转操作使用的鼠标按键
        distance: 92, // 默认视角距离主体的距离
        alpha: 41.5, // 让canvas在x轴有一定的倾斜角度
        beta: 3.6,
        zoomSensitivity: 0,
        rotateSensitivity: 0,
        panSensitivity: 0
      },
      // postEffect: {
      //   // 为画面添加高光，景深，环境光遮蔽（SSAO），调色等效果
      //   enable: true, // 是否开启
      //   SSAO: {
      //     // 环境光遮蔽
      //     radius: 1, // 环境光遮蔽的采样半径。半径越大效果越自然
      //     intensity: 1, // 环境光遮蔽的强度
      //     enable: true
      //   }
      // },
      temporalSuperSampling: {
        // 分帧超采样。在开启 postEffect 后，WebGL 默认的 MSAA 会无法使用,分帧超采样用来解决锯齿的问题
        enable: true
      },
      itemStyle: {
        // 三维图形的视觉属性
        color: 'rgba(1,1,1,0)',
        opacity: 0,
        borderWidth: 1,
        borderColor: 'transparent'
      },
      boxHeight: 0.5,
      regionHeight: 0.5 // 区域的高度
    },
    series: [
      {
        type: 'scatter3D',
        coordinateSystem: 'geo3D',
        data: shiGeoCoordMap[0],
        name: 'device',
        symbol: 'pin',
        symbolSize: 35,
        itemStyle: {
          color: 'transparent',
          borderColor: 'transparent',
          borderWidth: 2
        },
        label: {
          show: true,
          formatter: function(params) {
            var str = params.name
            return ['{name|' + str + '}', '{bg|b}'].join('\n')
          },
          position: 'top',
          distance: -40,
          rich: {
            name: {
              height: 20,
              width: 30,
              align: 'center',
              position: 'relative',
              color: '#85EBFF',
              fontSize: 16,
              borderWidth: 1,
              fontWeight: 'lighter',
              fontFamily: 'Microsoft YaHei',
              borderColor: 'transparent'
            },
            bg: {
              height: 30,
              width: 30,
              align: 'center',
              fontSize: 0,
              backgroundColor: {
                image: 'static/chart/img_cursor.png'
              },
              borderWidth: 1,
              borderColor: 'transparent'
            }
          }
        },
        emphasis: {
          label: {
            show: true,
            formatter: function(params) {
              var str = params.name
              return ['{name|' + str + '}', '{bg|b}'].join('\n')
            },
            position: 'top',
            distance: -40,
            rich: {
              name: {
                height: 20,
                width: 30,
                align: 'center',
                position: 'relative',
                color: '#A2FFE4',
                fontSize: 18,
                borderWidth: 1,
                fontWeight: '600',
                fontFamily: 'Microsoft YaHei',
                borderColor: 'transparent'
              },
              bg: {
                height: 35,
                width: 35,
                align: 'center',
                fontSize: 0,
                backgroundColor: {
                  image: 'static/chart/img_cursor_select.png'
                },
                borderWidth: 1,
                borderColor: 'transparent'
              }
            }
          }
        }
      },

      {
        type: 'scatter3D',
        coordinateSystem: 'geo3D',
        data: shiGeoCoordMap[1],
        name: 'show',
        symbol: 'pin',
        symbolSize: 35,
        itemStyle: {
          color: 'transparent',
          borderColor: 'transparent',
          borderWidth: 2
        },
        label: {
          show: true,
          formatter: function(params) {
            var str = params.name
            return ['{name|' + str + '}', '{bg|b}'].join('\n')
          },
          position: 'top',
          distance: -40,
          rich: {
            name: {
              height: 20,
              width: 30,
              align: 'center',
              position: 'relative',
              color: '#A2FFE4',
              fontSize: 18,
              borderWidth: 1,
              fontWeight: '600',
              fontFamily: 'Microsoft YaHei',
              borderColor: 'transparent'
            },
            bg: {
              height: 35,
              width: 35,
              align: 'center',
              fontSize: 0,
              backgroundColor: {
                image: 'static/chart/img_cursor_select.png'
              },
              borderWidth: 1,
              borderColor: 'transparent'
            }
          }
        },
        emphasis: {
          label: {
            show: true,
            formatter: function(params) {
              var str = params.name
              return ['{name|' + str + '}', '{bg|b}'].join('\n')
            },
            position: 'top',
            distance: -40,
            rich: {
              name: {
                height: 20,
                width: 30,
                align: 'center',
                position: 'relative',
                color: '#A2FFE4',
                fontSize: 18,
                borderWidth: 1,
                fontWeight: '600',
                fontFamily: 'Microsoft YaHei',
                borderColor: 'transparent'
              },
              bg: {
                height: 35,
                width: 35,
                align: 'center',
                fontSize: 0,
                backgroundColor: {
                  image: 'static/chart/img_cursor_select.png'
                },
                borderWidth: 1,
                borderColor: 'transparent'
              }
            }
          }
        }
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/china/chinaOption.js